export function getSidebarItemMotionDelay(custom: unknown): number {
    const position = typeof custom === 'number' ? custom : Number(custom) || 0;

    return 0.06 + position * 0.045;
}
